import http from "@/util/http.js"
const PREFIX = "/empresa"

export default {
	async autocomplete(text, page, size, customConfig) {
		return await http.get(PREFIX + "/autocomplete", { params: { page, text, size }, customConfig });
	},
	async consultar(cnpj, nome, page, size, customConfig) {
		return await http.get(PREFIX + "/consultar-empresa", { params: { cnpj, nome, page, size }, customConfig });
	},
	async contratoOptions(empresaId, customConfig) {
		return await http.get(PREFIX + "/contrato/options", { params: { empresaId }, customConfig });
	},
	async produtosOptions(empresaId, customConfig) {
		return await http.get(PREFIX + "/produtos/options", { params: { empresaId }, customConfig });
	},
	async getLastImportacao(empresaId, customConfig) {
		return await http.get(PREFIX + "/last-importacao/"+empresaId, { customConfig });
	},
	async getTravaImportacao(empresaId, contratoId, customConfig) {
		return await http.get(PREFIX + "/trava-importacao/"+empresaId+"/contrato/"+contratoId, { customConfig });
	},
	async getProduto(programaId, produtoId, customConfig) {
		return await http.get(PREFIX + "/contrato/programa/"+programaId+"/produto/"+produtoId, { customConfig });
	},
};